import React from 'react';
import HelpIcon from '@moda/icons/help-16';
import { Popover, Stack, Text, useBreakpoint } from '@moda/om';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import './LineItemShippingDetails.scss';

type Props = {
  granularity?: 'minimal' | 'full';
  item: LineItem;
};

export const LineItemShippingDetails: React.FC<Props> = ({
  granularity = 'full',
  item: {
    attributes: { expectedDeliveryTime, returnPolicy, isAvailableNow }
  }
}) => {
  const { matches: isDesktop } = useBreakpoint({ gt: 'md' });

  // This is a very hacky solution to patch the expected shipping time message with
  // a delay of a number of days specified in the "expected-delivery-delay-days" flag.
  const applyDelay = function (message: string | null | undefined, days: number) {
    if (message && message.includes('day') && isAvailableNow && days) {
      return message.replace(/\d+/g, d => String(Number(d) + days));
    }
    return message;
  };
  const delayDays = useFeatureFlag('expected-delivery-delay-days', [
    { default: 0 },
    { getFromTreatment: treatment => Number(treatment) }
  ]);
  const adjustedExpectedDeliveryTime = applyDelay(expectedDeliveryTime, delayDays);

  return (
    <Stack space={4}>
      {expectedDeliveryTime && (
        <Stack space={1} direction="horizontal" alignItems="center">
          <Text>{adjustedExpectedDeliveryTime}</Text>
          {granularity === 'full' && !isAvailableNow && (
            <Popover
              anchor={isDesktop ? 'bottomCenter' : 'bottomRight'}
              content={
                <div className="LineItemShippingDetails__popover-content">
                  You're ordering from next season's collection, and producing your piece may take
                  several months.
                </div>
              }
            >
              <HelpIcon />
            </Popover>
          )}
        </Stack>
      )}
      {granularity === 'full' && returnPolicy && <div>{returnPolicy}</div>}
      {!isAvailableNow && (
        <div>
          RESERVE TODAY
          <div>
            An advance payment of 50% is required at checkout.
            {granularity === 'full' &&
              ' The remaining balance will be charged when the item ships.'}
          </div>
        </div>
      )}
    </Stack>
  );
};
